const state = {
};

const getters = {
  state (state) {
    return state;
  },
  language (state) {
    return state.language;
  },
  showPrices (state) {
    return state.showPrices;
  },
  priceType (state) {
    return state.priceType;
  },
  showStock (state) {
    return state.showStock;
  },
  stockType (state) {
    return state.stockType;
  },
  stockLimit (state) {
    return state.stockLimit;
  },
  stockIndicators (state) {
    return state.stockIndicators;
  },
  showOrderProduct (state) {
    return state.showOrderProduct;
  },
  showFavorites (state) {
    return state.showFavorites;
  },
  groupProductsList (state) {
    return state.groupProductsList;
  },
  useCoupons (state) {
    return state.useCoupons;
  },
  useOrderLineComments (state) {
    return state.useOrderLineComments;
  },
  useMinimumOrderQuantity (state) {
    return state.useMinimumOrderQuantity;
  },
  hideShoppingCartImages (state) {
    return state.hideShoppingCartImages;
  },
  showEmptyShoppingCart (state) {
    return state.showClearCart;
  },
  condenseProductList (state) {
    return state.condenseProductList;
  },
  groupProducts (state) {
    return state.groupProducts;
  },
  filterSorting (state) {
    return state.filterSorting;
  },
  useOrderLineComments (state) {
    return state.useOrderLineComments;
  },
  productBlockSize (state) {
    return state.productBlockSize;
  },
  relatedProductBlockSize (state) {
    return state.relatedProductBlockSize;
  },
  minScore (state) {
    return state.minScore;
  },
  saleBannerColors (state) {
    return {
      color: state.saleBannerConfig.saleBannerColor,
      textColor: state.saleBannerConfig.saleBannerTextColor,
      text: state.saleBannerConfig.text
    }
  },
  ga4 (state) {
    return state.ga4;
  },
  orderNotLoggedOn (state) {
    return state.orderNotLoggedOn;
  },
  currencyData (state) {
    return state.currencyData;
  },
  bespokeGlobalWs (state) {
    return state.bespokeGlobalWs;
  }
};

const mutations = {
  setGlobalWsSettings (state, globalWsSettingsObj) {
    Object.assign(state, globalWsSettingsObj);
  }
};

const actions = {
  setGlobalWsSettings ({ commit }, globalWsSettings) {
    commit('setGlobalWsSettings', globalWsSettings);
  }
};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};
